import api from './api';

export async function getChatMessages() {
  const res = await api.get('/support/chats');
  return res.data.data;
}

export async function sendChatMessage(text) {
  const res = await api.post('/support/chats', { text });
  return res.data.data;
}
